/**
 * Telefon numarasını standart formata dönüştürür
 * Format: +1 818 456 7588
 * @param {string} phone - Ham telefon numarası
 * @returns {string} Formatlanmış telefon numarası
 */
export function formatPhoneNumber(phone) {
  if (!phone) return '';
  
  // Sadece rakamları al
  const cleaned = phone.replace(/\D/g, '');
  
  // Eğer 10 haneli değilse, orijinal değeri döndür
  if (cleaned.length !== 10) {
    return phone;
  }
  
  // Format: +1 XXX XXX XXXX
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `+1 ${match[1]} ${match[2]} ${match[3]}`;
  }
  
  return phone;
}

/**
 * Telefon numarası input'u için real-time formatlama
 * @param {string} value - Input değeri
 * @returns {string} Formatlanmış değer
 */
export function formatPhoneInput(value) {
  if (!value) return '';
  
  // Sadece rakamları al
  const cleaned = value.replace(/\D/g, '');
  
  // 10 haneden fazla ise kes
  if (cleaned.length > 10) {
    return formatPhoneNumber(cleaned.substring(0, 10));
  }
  
  // Kısmi formatlama
  if (cleaned.length >= 6) {
    return `+1 ${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6)}`;
  } else if (cleaned.length >= 3) {
    return `+1 ${cleaned.substring(0, 3)} ${cleaned.substring(3)}`;
  } else if (cleaned.length > 0) {
    return `+1 ${cleaned}`;
  }
  
  return '';
} 